(() => {
  let scheduled = false;

  function hideStickyCart() {
    scheduled = false;

    const nodes = Array.from(document.querySelectorAll('body *'));
    for (const el of nodes) {
      if (el.children.length > 0) continue;
      const text = (el.textContent || '').trim().replace(/\s+/g, ' ').toUpperCase();
      if (text !== 'VIEW YOUR CART') continue;

      let node = el;
      let best = null;

      for (let i = 0; i < 6 && node && node !== document.body; i += 1, node = node.parentElement) {
        const style = window.getComputedStyle(node);
        const rect = node.getBoundingClientRect();
        const compact = rect.width > 0 && rect.width < 520 && rect.height > 0 && rect.height < 180;

        if (compact && (style.position === 'fixed' || style.position === 'sticky')) {
          best = node;
          break;
        }

        if (compact) best = node;
      }

      const target = best || el.closest('a, button, [role="button"]') || el;
      target.style.setProperty('display', 'none', 'important');
      target.setAttribute('aria-hidden', 'true');

      const parent = target.parentElement;
      if (parent) {
        const parentText = (parent.textContent || '').trim().replace(/\s+/g, ' ').toUpperCase();
        const rect = parent.getBoundingClientRect();
        const style = window.getComputedStyle(parent);
        if (
          parentText.includes('VIEW YOUR CART') &&
          rect.width > 0 && rect.width < 520 &&
          rect.height > 0 && rect.height < 180 &&
          (style.position === 'fixed' || style.position === 'sticky')
        ) {
          parent.style.setProperty('display', 'none', 'important');
          parent.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }

  function scheduleHide() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(hideStickyCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHide, { once: true });
  } else {
    scheduleHide();
  }

  const observer = new MutationObserver(scheduleHide);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', scheduleHide, { once: true });
})();
